/* Auto-generated from figma/tokens/ — do not edit manually */
/* Run: npm run tokens:build */

import type { ThemeConfig } from '../theme/types'

export const trailheadConfig: ThemeConfig =
  {
    colors: {
      primary: '#3D5A3C',
      primaryHover: '#4A6B49',
      primaryActive: '#2E4A2D',
      accent: '#D4A84B',
      accentHover: '#C89A3E',
      background: '#FAF8F3',
      backgroundSecondary: '#F3EFE6',
      text: '#1A1A1A',
      textMuted: '#555555',
      border: '#E2DDD4',
      error: '#D93025',
      success: '#2E7D32',
      warning: '#E07B5A',
      sidebarBackground: '#3D5A3C',
      sidebarText: '#FAF8F3',
      sidebarTextMuted: '#B8C9B7',
      sidebarActiveBackground: '#4A6B49',
      sidebarActiveBorder: '#D4A84B',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#5B8FA8',
      secondaryHover: '#4E7F96',
      secondaryActive: '#4A7A92',
      errorHover: '#E04035',
      errorActive: '#C0281E',
      successHover: '#388E3C',
      successActive: '#1B5E20',
      warningHover: '#E58D6F',
      warningActive: '#D06A4A',
      focusRing: '#3D5A3C',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'md' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '0 1px 3px rgba(0,0,0,0.08)',
      cardBorderWidth: '1px',
      cardBorderRadius: '0.75rem',
      headingWeight: '600',
      headingLetterSpacing: '-0.01em',
      headingTextTransform: 'none',
      buttonRadius: '0.75rem',
      buttonWeight: '500',
      sidebarWidth: '200px',
      navItemRadius: '0',
      navItemBorderWidth: '3px',
      surfaceShadowSm: '0 1px 2px rgba(0,0,0,0.05)',
      surfaceShadowMd: '0 2px 8px rgba(0,0,0,0.08)',
      surfaceShadowLg: '0 4px 16px rgba(0,0,0,0.10)',
      borderWidth: '1px',
      dividerStyle: 'solid',
      transitionSpeed: '0.2s',
      backgroundTexture: 'none',
      badgeRadius: '9999px',
      inputRadius: '0.75rem',
      inputBorderWidth: '1px',
      density: 'comfortable',
      contentMaxWidth: '1400px',
      cardGap: '1rem',
      sidebarInset: '0px',
      sidebarRadius: '0',
      cardAccentBorder: 'none',
      cardBackground: 'var(--background)',
      cardBackdropBlur: '0',
      headingBorderBottom: 'none',
    },
    layout: {
      navigationMode: 'sidebar',
      exploreFilterPlacement: 'sidebar',
      topNavHeight: '64px',
    },
  }

export const emberConfig: ThemeConfig =
  {
    colors: {
      primary: '#E07B5A',
      primaryHover: '#E89070',
      primaryActive: '#D06A4A',
      accent: '#D4A84B',
      accentHover: '#C89A3E',
      background: '#1A1512',
      backgroundSecondary: '#252019',
      text: '#F5EDE5',
      textMuted: '#A89888',
      border: 'rgba(224,123,90,0.12)',
      error: '#F07070',
      success: '#6BBF80',
      warning: '#D4A84B',
      sidebarBackground: '#12100D',
      sidebarText: '#F5EDE5',
      sidebarTextMuted: '#7A6E60',
      sidebarActiveBackground: 'rgba(224,123,90,0.10)',
      sidebarActiveBorder: '#E07B5A',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#8B7BC8',
      secondaryHover: '#7D6DB8',
      secondaryActive: '#7B6BB8',
      errorHover: '#F58585',
      errorActive: '#E05555',
      successHover: '#7ECC90',
      successActive: '#55AF6A',
      warningHover: '#DDB560',
      warningActive: '#C49A3E',
      focusRing: '#E07B5A',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'xl' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '0 0 0 1px rgba(224,123,90,0.06), 0 4px 24px -4px rgba(224,123,90,0.12), 0 12px 40px -8px rgba(0,0,0,0.4)',
      cardBorderWidth: '1px',
      cardBorderRadius: '1.25rem',
      headingWeight: '500',
      headingLetterSpacing: '-0.02em',
      headingTextTransform: 'capitalize',
      buttonRadius: '0.875rem',
      buttonWeight: '500',
      sidebarWidth: '220px',
      navItemRadius: '0.75rem',
      navItemBorderWidth: '0',
      surfaceShadowSm: '0 0 0 1px rgba(224,123,90,0.04), 0 2px 12px -2px rgba(0,0,0,0.3)',
      surfaceShadowMd: '0 0 0 1px rgba(224,123,90,0.06), 0 8px 32px -4px rgba(224,123,90,0.10), 0 4px 16px rgba(0,0,0,0.3)',
      surfaceShadowLg: '0 0 0 1px rgba(224,123,90,0.08), 0 16px 48px -8px rgba(224,123,90,0.15), 0 8px 24px rgba(0,0,0,0.35)',
      borderWidth: '1px',
      dividerStyle: 'solid',
      transitionSpeed: '0.25s',
      backgroundTexture: 'radial-gradient(ellipse at 20% 50%, rgba(224,123,90,0.04) 0%, transparent 50%), radial-gradient(ellipse at 80% 20%, rgba(212,168,75,0.03) 0%, transparent 40%), radial-gradient(ellipse at 50% 100%, rgba(139,123,200,0.03) 0%, transparent 50%)',
      badgeRadius: '0.625rem',
      inputRadius: '0.875rem',
      inputBorderWidth: '1px',
      density: 'spacious',
      contentMaxWidth: '1100px',
      cardGap: '1.25rem',
      sidebarInset: '10px',
      sidebarRadius: '1rem',
      cardAccentBorder: 'none',
      cardBackground: 'rgba(37,32,25,0.65)',
      cardBackdropBlur: '16px',
      headingBorderBottom: 'none',
    },
    layout: {
      navigationMode: 'sidebar',
      exploreFilterPlacement: 'sidebar',
      topNavHeight: '64px',
    },
  }

export const tidepoolConfig: ThemeConfig =
  {
    colors: {
      primary: '#5B8FA8',
      primaryHover: '#4E7F96',
      primaryActive: '#3D6D84',
      accent: '#D4A84B',
      accentHover: '#C89A3E',
      background: '#F6F9FB',
      backgroundSecondary: '#FFFFFF',
      text: '#1A2830',
      textMuted: '#4A6070',
      border: '#1A2830',
      error: '#D93025',
      success: '#1A7A3A',
      warning: '#E07B5A',
      sidebarBackground: '#1A2830',
      sidebarText: '#F0F6FA',
      sidebarTextMuted: '#7A9AAC',
      sidebarActiveBackground: '#2A3A48',
      sidebarActiveBorder: '#D4A84B',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#E07B5A',
      secondaryHover: '#D06A4A',
      secondaryActive: '#C06A4A',
      errorHover: '#E04035',
      errorActive: '#C0281E',
      successHover: '#2A8A4A',
      successActive: '#0A6A2A',
      warningHover: '#E58D6F',
      warningActive: '#D06A4A',
      focusRing: '#5B8FA8',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'md' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '4px 4px 0 #1A2830',
      cardBorderWidth: '3px',
      cardBorderRadius: '0.75rem',
      headingWeight: '700',
      headingLetterSpacing: '0.02em',
      headingTextTransform: 'uppercase',
      buttonRadius: '0.75rem',
      buttonWeight: '700',
      sidebarWidth: '180px',
      navItemRadius: '0.5rem',
      navItemBorderWidth: '3px',
      surfaceShadowSm: '2px 2px 0 #1A2830',
      surfaceShadowMd: '4px 4px 0 #1A2830',
      surfaceShadowLg: '6px 6px 0 #1A2830',
      borderWidth: '3px',
      dividerStyle: 'solid',
      transitionSpeed: '0.1s',
      backgroundTexture: 'none',
      badgeRadius: '0.5rem',
      inputRadius: '0.75rem',
      inputBorderWidth: '3px',
      density: 'compact',
      contentMaxWidth: '1200px',
      cardGap: '0.75rem',
      sidebarInset: '0px',
      sidebarRadius: '0',
      cardAccentBorder: '5px solid #5B8FA8',
      cardBackground: '#FFFFFF',
      cardBackdropBlur: '0',
      headingBorderBottom: '3px solid #1A2830',
    },
    layout: {
      navigationMode: 'topnav',
      exploreFilterPlacement: 'topbar',
      topNavHeight: '56px',
    },
  }

export const canopyConfig: ThemeConfig =
  {
    colors: {
      primary: '#2D4A2C',
      primaryHover: '#3A5C39',
      primaryActive: '#203A1F',
      accent: '#8B7BC8',
      accentHover: '#7D6DB8',
      background: '#E8EDE4',
      backgroundSecondary: '#DDE4D8',
      text: '#1A2418',
      textMuted: '#5A6A54',
      border: 'rgba(45,74,44,0.08)',
      error: '#C0392B',
      success: '#3A7A40',
      warning: '#E07B5A',
      sidebarBackground: '#2A3C28',
      sidebarText: '#E0E8DC',
      sidebarTextMuted: '#8AA888',
      sidebarActiveBackground: '#344A32',
      sidebarActiveBorder: '#8B7BC8',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#6A5A8A',
      secondaryHover: '#5A4A7A',
      secondaryActive: '#4A3A6A',
      errorHover: '#D04435',
      errorActive: '#A12D20',
      successHover: '#4A8A50',
      successActive: '#2A6A30',
      warningHover: '#E58D6F',
      warningActive: '#D06A4A',
      focusRing: '#2D4A2C',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'xl' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '6px 6px 12px rgba(30,40,28,0.12), -4px -4px 10px rgba(255,255,255,0.5)',
      cardBorderWidth: '0',
      cardBorderRadius: '1.25rem',
      headingWeight: '500',
      headingLetterSpacing: '0',
      headingTextTransform: 'none',
      buttonRadius: '1rem',
      buttonWeight: '500',
      sidebarWidth: '230px',
      navItemRadius: '0.75rem',
      navItemBorderWidth: '0',
      surfaceShadowSm: '3px 3px 6px rgba(30,40,28,0.08), -2px -2px 5px rgba(255,255,255,0.4)',
      surfaceShadowMd: '6px 6px 12px rgba(30,40,28,0.12), -4px -4px 10px rgba(255,255,255,0.5)',
      surfaceShadowLg: '10px 10px 20px rgba(30,40,28,0.15), -6px -6px 14px rgba(255,255,255,0.6)',
      borderWidth: '0',
      dividerStyle: 'solid',
      transitionSpeed: '0.25s',
      backgroundTexture: 'radial-gradient(circle at 30% 20%, rgba(139,123,200,0.04) 0%, transparent 35%), radial-gradient(circle at 75% 75%, rgba(45,74,44,0.03) 0%, transparent 40%)',
      badgeRadius: '9999px',
      inputRadius: '1rem',
      inputBorderWidth: '0',
      density: 'spacious',
      contentMaxWidth: '1400px',
      cardGap: '1.5rem',
      sidebarInset: '12px',
      sidebarRadius: '1.25rem',
      cardAccentBorder: 'none',
      cardBackground: '#E8EDE4',
      cardBackdropBlur: '0',
      headingBorderBottom: 'none',
    },
    layout: {
      navigationMode: 'sidebar',
      exploreFilterPlacement: 'sidebar',
      topNavHeight: '64px',
    },
  }

export const expeditionConfig: ThemeConfig =
  {
    colors: {
      primary: '#8B5E2A',
      primaryHover: '#9B6E3A',
      primaryActive: '#7B4E1A',
      accent: '#E07B5A',
      accentHover: '#D06A4A',
      background: '#FBF7F0',
      backgroundSecondary: '#F2EBDD',
      text: '#2A1F14',
      textMuted: '#6A5A48',
      border: '#2A1F14',
      error: '#C0392B',
      success: '#3A7A40',
      warning: '#D4A84B',
      sidebarBackground: '#2A1F14',
      sidebarText: '#F5EDDE',
      sidebarTextMuted: '#A89878',
      sidebarActiveBackground: '#3E3024',
      sidebarActiveBorder: '#E07B5A',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#D4A84B',
      secondaryHover: '#C89A3E',
      secondaryActive: '#B8900E',
      errorHover: '#D04435',
      errorActive: '#A12D20',
      successHover: '#4A8A50',
      successActive: '#2A6A30',
      warningHover: '#DDB560',
      warningActive: '#C49A3E',
      focusRing: '#8B5E2A',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'sm' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '5px 5px 0 rgba(42,31,20,0.18)',
      cardBorderWidth: '2.5px',
      cardBorderRadius: '0.25rem',
      headingWeight: '700',
      headingLetterSpacing: '0.10em',
      headingTextTransform: 'uppercase',
      buttonRadius: '0.125rem',
      buttonWeight: '700',
      sidebarWidth: '190px',
      navItemRadius: '0',
      navItemBorderWidth: '4px',
      surfaceShadowSm: '3px 3px 0 rgba(42,31,20,0.12)',
      surfaceShadowMd: '5px 5px 0 rgba(42,31,20,0.18)',
      surfaceShadowLg: '7px 7px 0 rgba(42,31,20,0.22)',
      borderWidth: '2.5px',
      dividerStyle: 'dotted',
      transitionSpeed: '0.1s',
      backgroundTexture: 'url("data:image/svg+xml,%3Csvg width=\'200\' height=\'200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 80 Q 50 60, 100 80 T 200 80\' fill=\'none\' stroke=\'%232A1F14\' stroke-width=\'0.5\' opacity=\'0.04\'/%3E%3Cpath d=\'M0 120 Q 50 100, 100 120 T 200 120\' fill=\'none\' stroke=\'%232A1F14\' stroke-width=\'0.5\' opacity=\'0.04\'/%3E%3Cpath d=\'M0 40 Q 50 20, 100 40 T 200 40\' fill=\'none\' stroke=\'%232A1F14\' stroke-width=\'0.5\' opacity=\'0.04\'/%3E%3Cpath d=\'M0 160 Q 50 140, 100 160 T 200 160\' fill=\'none\' stroke=\'%232A1F14\' stroke-width=\'0.5\' opacity=\'0.04\'/%3E%3Ccircle cx=\'150\' cy=\'50\' r=\'2\' fill=\'%232A1F14\' opacity=\'0.03\'/%3E%3Ccircle cx=\'30\' cy=\'150\' r=\'1.5\' fill=\'%232A1F14\' opacity=\'0.03\'/%3E%3C/svg%3E")',
      badgeRadius: '0',
      inputRadius: '0.125rem',
      inputBorderWidth: '2.5px',
      density: 'spacious',
      contentMaxWidth: '960px',
      cardGap: '1.5rem',
      sidebarInset: '0px',
      sidebarRadius: '0',
      cardAccentBorder: '5px solid #E07B5A',
      cardBackground: '#FBF7F0',
      cardBackdropBlur: '0',
      headingBorderBottom: '3px dotted #2A1F14',
    },
    layout: {
      navigationMode: 'topnav',
      exploreFilterPlacement: 'topbar',
      topNavHeight: '60px',
    },
  }

export const stardustConfig: ThemeConfig =
  {
    colors: {
      primary: '#8B7BC8',
      primaryHover: '#9B8BD8',
      primaryActive: '#7B6BB8',
      accent: '#D4A84B',
      accentHover: '#C89A3E',
      background: '#110F1A',
      backgroundSecondary: '#1A1726',
      text: '#E4E0F0',
      textMuted: '#8A84A0',
      border: 'rgba(139,123,200,0.15)',
      error: '#F07070',
      success: '#6BBF80',
      warning: '#D4A84B',
      sidebarBackground: '#0C0A14',
      sidebarText: '#E4E0F0',
      sidebarTextMuted: '#5A5470',
      sidebarActiveBackground: 'rgba(139,123,200,0.10)',
      sidebarActiveBorder: '#D4A84B',
      accentB2C: '#E07B5A',
      accentSchools: '#D4A84B',
      accentProviders: '#5B8FA8',
      secondary: '#5B8FA8',
      secondaryHover: '#4E7F96',
      secondaryActive: '#4A7A92',
      errorHover: '#F58585',
      errorActive: '#E05555',
      successHover: '#7ECC90',
      successActive: '#55AF6A',
      warningHover: '#DDB560',
      warningActive: '#C49A3E',
      focusRing: '#8B7BC8',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'full' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '0 0 0 1px rgba(139,123,200,0.10), 0 4px 20px -4px rgba(139,123,200,0.18), 0 12px 40px -8px rgba(0,0,0,0.4)',
      cardBorderWidth: '1px',
      cardBorderRadius: '1.5rem',
      headingWeight: '400',
      headingLetterSpacing: '0.03em',
      headingTextTransform: 'none',
      buttonRadius: '9999px',
      buttonWeight: '500',
      sidebarWidth: '220px',
      navItemRadius: '9999px',
      navItemBorderWidth: '0',
      surfaceShadowSm: '0 0 12px rgba(139,123,200,0.08), 0 2px 6px rgba(0,0,0,0.2)',
      surfaceShadowMd: '0 0 24px rgba(139,123,200,0.12), 0 4px 16px rgba(0,0,0,0.3)',
      surfaceShadowLg: '0 0 40px rgba(139,123,200,0.16), 0 8px 32px rgba(0,0,0,0.35), 0 0 80px rgba(212,168,75,0.04)',
      borderWidth: '1px',
      dividerStyle: 'dashed',
      transitionSpeed: '0.4s',
      backgroundTexture: 'radial-gradient(ellipse at 15% 30%, rgba(139,123,200,0.06) 0%, transparent 45%), radial-gradient(ellipse at 85% 15%, rgba(212,168,75,0.04) 0%, transparent 35%), radial-gradient(ellipse at 50% 85%, rgba(224,123,90,0.03) 0%, transparent 40%), radial-gradient(ellipse at 70% 60%, rgba(91,143,168,0.03) 0%, transparent 35%)',
      badgeRadius: '9999px',
      inputRadius: '9999px',
      inputBorderWidth: '1px',
      density: 'spacious',
      contentMaxWidth: '1300px',
      cardGap: '1.5rem',
      sidebarInset: '10px',
      sidebarRadius: '1.5rem',
      cardAccentBorder: 'none',
      cardBackground: 'rgba(26,23,38,0.55)',
      cardBackdropBlur: '12px',
      headingBorderBottom: '1px dashed rgba(139,123,200,0.3)',
    },
    layout: {
      navigationMode: 'sidebar',
      exploreFilterPlacement: 'drawer',
      topNavHeight: '64px',
    },
  }

export const fieldJournalConfig: ThemeConfig =
  {
    colors: {
      primary: '#5b7c3a',
      primaryHover: '#4a6830',
      primaryActive: '#3f5a28',
      accent: '#b8860b',
      accentHover: '#a07508',
      background: '#faf6ee',
      backgroundSecondary: '#f3ede0',
      text: '#3a3226',
      textMuted: '#6b5d3e',
      border: '#c4b68a',
      error: '#c4553a',
      success: '#8aad5c',
      warning: '#d4883a',
      sidebarBackground: '#3a3226',
      sidebarText: '#faf6ee',
      sidebarTextMuted: '#c4b68a',
      sidebarActiveBackground: '#4d4335',
      sidebarActiveBorder: '#b8860b',
      accentB2C: '#c4553a',
      accentSchools: '#d4b85a',
      accentProviders: '#4a7a9b',
      secondary: '#6b5d3e',
      secondaryHover: '#5a4e34',
      secondaryActive: '#4A3E2E',
      errorHover: '#D0654A',
      errorActive: '#B0453A',
      successHover: '#98BB6C',
      successActive: '#7A9D4C',
      warningHover: '#DD994D',
      warningActive: '#C47A30',
      focusRing: '#5b7c3a',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyMono: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    },
    spacing: { borderRadius: 'md' },
    branding: { logoUrl: null, logoAlt: 'DOcurious Logo', appName: 'DOcurious' },
    style: {
      cardShadow: '1px 2px 0 rgba(58,50,38,0.06)',
      cardBorderWidth: '1.5px',
      cardBorderRadius: '0.5rem',
      headingWeight: '600',
      headingLetterSpacing: '0.01em',
      headingTextTransform: 'none',
      buttonRadius: '0.375rem',
      buttonWeight: '600',
      sidebarWidth: '200px',
      navItemRadius: '0.25rem',
      navItemBorderWidth: '3px',
      surfaceShadowSm: '1px 1px 0 rgba(58,50,38,0.04)',
      surfaceShadowMd: '1px 2px 0 rgba(58,50,38,0.06)',
      surfaceShadowLg: '2px 3px 0 rgba(58,50,38,0.08)',
      borderWidth: '1.5px',
      dividerStyle: 'dashed',
      transitionSpeed: '0.2s',
      backgroundTexture: 'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence baseFrequency=\'0.55\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\' opacity=\'0.02\'/%3E%3C/svg%3E")',
      badgeRadius: '0.25rem',
      inputRadius: '0.375rem',
      inputBorderWidth: '1.5px',
      density: 'comfortable',
      contentMaxWidth: '1000px',
      cardGap: '1rem',
      sidebarInset: '0px',
      sidebarRadius: '0',
      cardAccentBorder: 'none',
      cardBackground: '#faf6ee',
      cardBackdropBlur: '0',
      headingBorderBottom: 'none',
    },
    layout: {
      navigationMode: 'topnav',
      exploreFilterPlacement: 'drawer',
      topNavHeight: '56px',
    },
  }
